import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';

export const carpetPadNode = (state) => state.carpetPad;

export const getCurrentCarpetChoices = createSelector(
  carpetPadNode,
  (carpet) => carpet.currentCarpetChoices
);

export const selectPrefetchedChoicesByHDMSSku = (carpetHdmsSku) => createSelector(
  getCurrentCarpetChoices,
  (choices) => choices?.[carpetHdmsSku]
);

export const selectedCarpetPad = createSelector(
  carpetPadNode,
  (carpet) => carpet.selectedCarpetPad,
);

export const getFetchedCarpetPads = createSelector(
  carpetPadNode,
  (carpet) => sortBy(carpet.fetchedPadsByChoice, (cp) => cp.padUIOrder)
);

export const getCurrentCarpetPadChoices = createSelector(
  carpetPadNode,
  (carpet) => carpet.fetchedPadsByChoice,
);

export const hasSelectedCarpetPadSelector = createSelector(
  selectedCarpetPad,
  (selection) => !!selection?.id
);
